<template>
  <div class="card__wrapper">
    <div class="card">
      <h1 class="card__title">{{ $t('messages.cart') }}</h1>
      <div class="card__description">
        <b-table striped bordered stacked="md" :items="items" :fields="fields" v-if="$store.state.orders.length > 0" class="products-table">
          <template v-slot:cell(image)="row">
            <b-img :src="row.item.image" fluid :alt="row.item.name" @click="navigateToProduct(row.item)" class="pointer" />
          </template>

          <template v-slot:cell(amount)="row">
            <div class="d-flex">
              <b-form-input min="0" :number="true" type="number" class="mr-1"
                            v-model="amounts[row.index]" @input="updateCart(row.index, row.item)"></b-form-input>
              <b-button variant="primary" @click="removeOrder(row.item)">
                <font-awesome-icon icon="trash-alt"></font-awesome-icon>
              </b-button>
            </div>
          </template>

          <template v-slot:cell(price)="row">
            € {{ row.item.price | round(2) }}
          </template>

          <template v-slot:cell(total)="row">
            € {{ (row.item.amount * row.item.price) | round(2) }}
          </template>
        </b-table>
        <span v-if="$store.state.orders.length === 0" class="font-italic">{{ $t('messages.cart_empty') }}</span>
        <div v-if="$store.state.orders.length > 0" class="d-flex flex-column align-items-end">
          <p class="mr-1" v-if="$store.state.discounted">
            <span class="font-weight-bold">{{ $t('messages.total_sub') }}</span>: € {{ subTotalSum | round(2) }}
          </p>
          <p class="mr-1 red" v-if="$store.state.discounted">
            <span class="font-weight-bold">{{ $t('messages.discount') }}</span>: € {{ discountSum | round(2) }}
          </p>
          <p class="mr-1 mt-2 mb-3">
            <span class="font-weight-bold">{{ $t('messages.total') }}</span>: € {{ totalSum | round(2) }}
          </p>
        </div>
        <div class="d-flex" v-if="$store.state.orders.length > 0">
          <div>
            <b-button variant="primary" :to="{ path: '/store' }">{{ $t('messages.cart_continue') }}</b-button>
          </div>
          <div class="ml-auto">
            <b-button variant="primary" :disabled="!isValid" :to="{ path: '/delivery' }">{{ $t('messages.delivery_continue') }}</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import { defaultMixin } from '../../mixin/default'
import { productService } from '../../services/product.service'

export default {
  name: 'cart',
  metaInfo: function () {
    return {
      title: this.$i18n.t('messages.cart') + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.$i18n.t('messages.cart'),
          'vmid': 'og:title'
        }
      ]
    }
  },
  mixins: [ defaultMixin ],
  data: function () {
    return {
      fields: [{
        key: 'image',
        label: this.$i18n.t('messages.image'),
        tdClass: 'td-image'
      }, {
        key: 'name',
        label: this.$i18n.t('messages.name')
      }, {
        key: 'amount',
        label: this.$i18n.t('messages.number'),
        tdClass: 'td-info'
      }, {
        key: 'price',
        label: this.$i18n.t('messages.price'),
        tdClass: 'td-info'
      }, {
        key: 'total',
        label: this.$i18n.t('messages.total'),
        tdClass: 'td-info'
      }],
      amounts: this.$store.state.orders.map(order => order.amount)
    }
  },
  computed: {
    items: function () {
      let hasDanger = false
      let items = this.$store.state.orders
      items.forEach(function (item) {
        if (!item.preorder && !item.backorder && (item.amount > item.stock)) {
          item._rowVariant = 'danger'
          hasDanger = true
        } else {
          item._rowVariant = null
        }
      })
      if (hasDanger) {
        this.$store.commit('error', 'errors.stock_exhausted_overview')
      } else {
        this.$store.commit('clear')
      }
      return items
    },
    isValid: function () {
      let isValid = true
      this.$store.state.orders.forEach(function (item) {
        if (!item.preorder && !item.backorder && (item.amount > item.stock)) {
          isValid = false
        }
      })
      return isValid
    },
    subTotalSum: function () {
      return this.$store.state.orders.map(order => order.amount * order.price).reduce((a, b) => a + b, 0)
    },
    discountSum: function () {
      if (this.$store.state.discounted) {
        return this.$store.state.orders.filter(order => !order.orderedBefore).map(order => order.price - order.reducedPrice).reduce((a, b) => a + b, 0)
      } else {
        return null
      }
    },
    totalSum: function () {
      return this.subTotalSum - (this.discountSum ? this.discountSum : 0)
    }
  },
  methods: {
    updateCart: _.debounce(function (index, item) {
      item.amount = this.amounts[index]
      this.$store.commit('modifyOrder', item)
    }, 1000),
    removeOrder: function (item) {
      this.$store.commit('removeOrder', item)
      this.amounts = this.$store.state.orders.map(order => order.amount)
    },
    navigateToProduct: function (product) {
      this.$router.push('/product/' + this.slugText(product.id + '/' + product.name))
    }
  },
  created: function () {
    // Update cart
    if (this.$store.state.orders && this.$store.state.orders.length > 0) {
      let loader = this.$loading.show()

      let total = this.$store.state.orders.length
      let counter = 0
      this.$store.state.orders.forEach(function (order) {
        productService.get(order.id)
          .then((product) => {
            order.preorder = product.preorder
            order.backorder = product.backorder
            order.stock = product.stock
            order.price = product.price
            order.reducedPrice = product.reduced_price
            order.orderedBefore = product.ordered_before
            counter++

            if (counter === total) {
              loader.hide()
            }
          }, () => {})
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .table >>> .td-image img {
    max-height: 100px !important;
  }

  @media screen and (min-width: 768px) {
    .table >>> .td-image {
      width: 150px !important;
      text-align: center;
    }

    .table >>> .td-info {
      width: 150px !important;
    }
  }

  .table >>> td {
    vertical-align: middle !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/Cart.vue